import type { IChangeFilterItems } from "app/components/filters-bar/change-filter/ChangeFilter";
import { EChangeFilterValues } from "app/components/filters-bar/change-filter/ChangeFilter";
import { translate } from "app/filters/i18nFilter";

export const changeFilterItems: IChangeFilterItems[] = [
    {
        get text() {
            return translate("change.filter.trending");
        },
        id: EChangeFilterValues.Trending,
        get tooltip() {
            return translate("change.filter.landing.pages.trending.tooltip");
        },
    },
    {
        get text() {
            return translate("change.filter.de-trending");
        },
        id: EChangeFilterValues.DeTrending,
        get tooltip() {
            return translate("change.filter.landing.pages.detrending.tooltip");
        },
    },
    {
        get text() {
            return translate("change.filter.lost-clicks");
        },
        id: EChangeFilterValues.LostClicks,
        get tooltip() {
            return translate("change.filter.landing.pages.lost.tooltip");
        },
    },
    {
        get text() {
            return translate("change.filter.new-clicks");
        },
        id: EChangeFilterValues.NewClicks,
        get tooltip() {
            return translate("change.filter.landing.pages.new.tooltip");
        },
    },
];
